import { TIME_CONSTANTS } from "../constants/time";

export const formatTimeFromSeconds = (seconds) => {
  if (!seconds) return "-";

  const hours = Math.floor(seconds / TIME_CONSTANTS.SECONDS_PER_HOUR);
  const minutes = Math.floor(
    (seconds % TIME_CONSTANTS.SECONDS_PER_HOUR) / 60
  );

  if (hours >= TIME_CONSTANTS.HOURS_PER_DAY) {
    const days = Math.floor(hours / TIME_CONSTANTS.HOURS_PER_DAY);
    const remainingHours = hours % TIME_CONSTANTS.HOURS_PER_DAY;
    return `${days}d ${remainingHours}h ${minutes}m`;
  }

  return hours > 0 ? `${hours}h ${minutes}m` : `${minutes}m`;
};
